import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppShell } from "../components/AppShell";
import { hrefWithDemoViewer, useDemoViewer, } from "../domain/demo-viewer";
export function NotFoundPage({ path }) {
    const { viewer } = useDemoViewer();
    return (_jsx(AppShell, { active: "home", children: _jsxs("section", { className: "not-found", children: [_jsx("p", { className: "section-kicker", children: "Page not found" }), _jsx("h1", { children: path }), _jsx("a", { href: hrefWithDemoViewer("/home/", viewer), children: "Return to Home Feed" })] }) }));
}
